<!-- ToDo nur anzeigen, wenn CustomerType "PX" ist -->
<mat-card class="card">
    <div class="card-header">
        <fa-icon class="icon" icon="user-md"></fa-icon>

        <h3>Behandler</h3>

        <a
            app-round-button
            [routerLink]="['behandler', 'neuerBehandler']"
            matTooltip="Hinzufügen"
            matTooltipPosition="left"
            [Disabled]="(Customer$ | async)?.Deleted"
        >
            <fa-icon icon="plus"></fa-icon>
        </a>
    </div>

    <!-- CSS-Klasse ist nur für den inset box shadow -->
    <div class="clickable-list-container" >
        <mat-nav-list *ngIf="(ShownDoctorsList$ | async)?.length; else noContent">
            <a
                mat-list-item
                [routerLink]="'behandler/' + Doctor.Id"
                *ngFor="let Doctor of ShownDoctorsList$ | async"
            >
                <div mat-line>
                    <span>{{ Doctor.Lanr }}</span>
                    <span>{{ Doctor.Name }}</span>
                    <span>{{ Doctor.IsActive ? '' : 'in' }}aktiv</span>
                </div>

                <mat-divider></mat-divider>
            </a>
        </mat-nav-list>
    </div>
</mat-card>
<ng-template #noContent>
    <table class="clickable-list-container">
        <tr>
            <td class="empty-table-text">Keine Behandler vorhanden</td>
        </tr>
    </table>
</ng-template>
